export default function PHP_sha1() {
  return (
    <div>
      <h1>PHP_sha1</h1>
    </div>
  );
}
